<template>
  <div class="mobile-table-content">
    <div class="table-title">
      <div class="title-left"><i class="el-icon-s-management" />投放信息</div>
      <div class="title-right"></div>
    </div>
    <!-- 投放信息 -->
    <div class="list-content">
      <CommonDetail :listConfig="listConfig" :listData="formOneData">
      </CommonDetail>
    </div>
    <template>
      <div class="table-title">
        <div class="title-left">
          <i class="el-icon-s-management" />其他应收款项
        </div>
        <div class="title-right"></div>
      </div>
      <!-- 其他应收款项 -->
      <TableCustom
        :readOnly="true"
        :tableParams="tableParams"
        :tableData="tableData"
        style="margin-left: 10px"
      >
      </TableCustom>
    </template>
    <template>
      <div class="table-title">
        <div class="title-left">
          <i class="el-icon-s-management" />本批次投放信息
        </div>
        <div class="title-right"></div>
      </div>
      <!-- 本批次投放信息 -->

      <div class="list-content">
        <CommonDetail :listConfig="listBatchConfig" :listData="formTwoData">
        </CommonDetail>
      </div>
    </template>
  </div>
</template>
<script>
import CommonDetail from "@/components/workflowComponents/mobile/commonDetail";
import TableCustom from "@/components/tableCustom/tableCustom";
import { mapGetters } from "vuex";
import * as api from "@/api/factoring/factoring";
import SelectInput from "@/components/commonSelect/selectInput";
import SelectDrawer from "@/components/workflowComponents/mobile/selectDrawer";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util";
import { floatAdd } from "@/util/util";
export default {
  name: "mobileInvestmentLoanManagement",
  mixins: [workFlow, util],
  data() {
    return {
      tableData: [],
      formOneData:{},
      formTwoData:{},
      listConfig: [
        {
          label: "项目名称",
          prop: "projectName",
          // propInner:'name'
        },
        {
          label: "保理类型",
          prop: "projectTypeStr",
          // propInner:'projectTypeStr'
        },
        {
          label: "项目融资额度",
          prop: "factoringCredit",
          // propInner:'factoringCredit',
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        // {
        //   label: "已用额度",
        //   prop: "usedFinancingQuota",
        //   formatter: (label, value) => {
        //     return this.getMoney(value) + "元";
        //   },
        // },
        // {
        //   label: "可用额度",
        //   prop: "usableFinancingQuota",
        //   formatter: (label, value) => {
        //     return this.getMoney(value) + "元";
        //   },
        // },
        {
          label: "保理合同",
          prop: "contractName",
        },
        {
          label: "报价方案",
          prop: "quotaName",
        },

        {
          label: "合同金额",
          prop: "contractFactoringCredit",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },

        {
          label: "卖方（债权人）",
          prop: "sellerCustName",
        },
        // {
        //   label: "首付款",
        //   prop: "formAccountingEntityStr",
        // },
        {
          label: "还款期限",
          prop: "leaseTerm",
          formatter: (label, value) => {
            return value + "天";
          },
        },
        {
          label: "是否申请宽限期",
          prop: "graceFlagStr",
        },
        {
          label: "宽限期及使用费率",
          prop: "gracePeriodDayRate",
        },
        // {
        //   label: "逾期使用费率",
        //   prop: "overdueInterestRateStr",
        // },
        {
          label: "内部收益率",
          prop: "xirrStr",
          formatter: (label, value) => {
            return value + "%";
          },
        },
        
        {
          label: "还款频次",
          prop: "repaymentFrequencyStr",
        },
        // {
        //   label: "保理商",
        //   prop: "factoringEntity",
        // },
        // {
        //   label: "其他条件",
        //   prop: "remark",
        // },
      ],
      listBatchConfig: [
        {
          label: "放款批次",
          prop: "investBatchStr",
        },
        {
          label: "本批次投放金额",
          prop: "investAmount",
          formatter: (label, value) => {
            return value + "元";
          },
        },
        {
          label: "需内扣金额",
          prop: "innerReduce",
          formatter: (label, value) => {
            return value + "元";
          },
        },
        {
          label: "净投放金额",
          prop: "netInvestAmount",
          formatter: (label, value) => {
            return value + "元";
          },
        },
        {
          label: "预计起息日",
          prop: "rentDate",
        },
        {
          label: "投放条件是否已落实",
          prop: "isInvestCondition",
          formatter: (label, value) => {
            return value == 1 ? "是" : value == 0 ? "否" : "无";
          },
        },
        {
          label: "收款方银行信息",
          prop: "bankInfo",
          type: "textarea",
        },
        {
          label: "其他投放条件",
          prop: "otherCondition",
          type: "textarea",
        },
      ],
      tableParams: {
        index: true,
        indexLabel: "序号",
        align: "center",
        column: [
          {
            label: "款项类型",
            prop: "outlayTypeStr",
          },
          {
            label: "比例/金额",
            prop: "moneyRate",
          },
          {
            label: "是否内扣",
            prop: "isBuckle",
          },
          {
            label: "计划收取时间",
            prop: "planDate",
          },
          // {
          //   label: "其他",
          //   prop: "",
          // },
        ],
      },
    };
  },
  components: {
    CommonDetail,
    SelectInput,
    SelectDrawer,
    TableCustom,
  },
  props: {
    listData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    flowData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    listData: {
      handler(newData, oldData) {
        if (newData.id && newData.id != "") {
          this.dealDetailData(newData);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async dealDetailData(initData) {
            let self = this
            let dataOne = {}
            let dataTwo = {}
            let awaitOne = this.queryDict(initData.blReportStandard.projectType, '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type')
            let awaitTwo = api.getUsedAmount({id: initData.blReportStandard.projectInfoId})
            let awaitThree = this.queryDict(initData.blContractRental.repaymentFrequency, '/api/blade-system/dict-biz/dictionary?code=repayment_frequency')
            let awaitFour = this.queryBankId(initData.bankId)
            
            dataOne.projectName = initData.blReportStandard.name
            dataOne.custId = initData.custId
            dataOne.selectId = initData.reportId
            dataOne.projectTypeStr = initData.blReportStandard.projectTypeStr
            //合同信息
            dataOne.selectId = initData.contractId
            dataOne.rentId = initData.blContractRental.id
            dataOne.selectBankId = initData.bankId
            dataOne.investCredit = initData.thisInvestMoney
            dataOne.contractName = initData.contractManage.contractName
            dataOne.quotaName = initData.blContractRental.name
            dataOne.sellerCustName = initData.blReportStandard.sellerCustName
            dataOne.contractFactoringCredit = this.getMoney(Number(initData.blContractRental.quotationPrice))
            dataOne.downPayment = initData.blContractRental.downPayment.split(',')[1]
            dataOne.downPaymentStr = this.getMoney(Number(initData.blContractRental.downPayment.split(',')[1]))
            dataOne.downPaymentRate = initData.blContractRental.downPayment.split(',')[0]
            dataOne.leaseTerm = initData.blContractRental.leaseTerm
            dataOne.graceFlagStr = initData.blContractRental.graceFlag == -1?'无':initData.blContractRental.graceFlag == 0?'否':'是'
            // dataTwo.gracePeriodDay = initData.blContractRental.gracePeriodDay
            // dataTwo.graceInterestRate = initData.blContractRental.graceInterestRate
            dataOne.gracePeriodDayRate = initData.blContractRental.gracePeriodDay && initData.blContractRental.gracePeriodDay !== -1?`${Number(initData.blContractRental.gracePeriodDay)}天,${Number(initData.blContractRental.graceInterestRate)*100}%`:'无'
            dataOne.xirrStr = (Number(initData.blContractRental.xirr)*100).toFixed(4)
            dataOne.annualInterestRate = (Number(initData.blContractRental.annualInterestRate)*100).toFixed(4)

            let promiseList = [awaitTwo,awaitThree,awaitFour]
            dataTwo.innerReduce = 0
            initData.otherOutlayVOS.map(item => {
                item = self.dealTableData(item)
                // 需内扣总金额
                if(item.outlayWay == 1){
                    dataTwo.innerReduce =floatAdd(dataTwo.innerReduce,Number(item.outlayAmount))                         
                }
            
            })
            self.tableData = initData.otherOutlayVOS

            // 批次放款信息
            dataTwo.investBatchStr = `第${initData.investBatch}批`

            dataTwo.rentDate = initData.rentDate
            // 本批次投放金额
            dataTwo.investAmount = this.getMoney(Number(initData.blContractRental.quotationPrice))
            // dataTwo.innerReduce = this.getMoney(Number(initData.blContractRental.quotationPrice) - Number(initData.cleanMoney))
            dataTwo.innerReduceStr = `${this.getMoney(dataTwo.innerReduce)}`
            dataTwo.netInvestAmount = Number(initData.blContractRental.quotationPrice - dataTwo.innerReduce)
            dataTwo.netInvestAmountStr = `${this.getMoney(Number(dataTwo.netInvestAmount))}`            
            // 需内扣金额
            dataTwo.isInvestCondition = initData.isInvestCondition
            dataTwo.isInvestConditionStr = initData.isInvestCondition == 0?'否':'是'
            dataTwo.otherCondition = initData.remarks
            
            Promise.all(promiseList).then(res => {
                // 基础信息
                let amountData = res[0]
                dataOne.repaymentFrequencyStr = res[1]
                // 银行信息

                dataOne.factoringCredit = Number(self.listData.blReportStandard.factoringCredit)
                dataOne.factoringCreditStr = self.getMoney(Number(self.listData.blReportStandard.factoringCredit))
                // 查询已用额度
                dataOne.usedFinancingQuota = `${(self.getMoney(Number(amountData.data.data)))}`
                // 可用额度
                dataOne.usableFinancingQuota = `${self.getMoney(Number(dataOne.factoringCredit)-Number(amountData.data.data))}`

                dataTwo.bankInfo = `${res[2].records[0].bankAccountName} ${res[2].records[0].bankOpenName} ${res[2].records[0].bankNo}`
                dataTwo.bankId = res[2].records[0].id
                self.formOneData = {...dataOne}
                self.formTwoData = {...dataTwo}
            })
    },
    queryBankId(id) {
      return new Promise(async (resolve, reject) => {
        let res = await api.queryBankInfo({ id });
        if (res.data.code == 200) resolve(res.data.data);
      });
    },
    dealTableData(data) {
      data.moneyRate = `${(Number(data.outlayRate) * 100).toFixed(
        4
      )}% / ${this.getMoney(Number(data.outlayAmount))}元`;
      data.isBuckle = data.outlayWay == 1 ? "是" : "否";
      data.investId = this.virtualId;
      data.outlayId = data.otherOutlayId;
      return data;
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile-table-content {
  .table-title {
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1rem;
    margin-top: 0.2rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    .title-left {
      font-size: .38rem;
      color: #666;
      font-weight: 600;
    }
    .title-right {
      font-size: .38rem;
      color: #ccc;
    }
  }
  .list-content {
    .info-one {
      background-color: #fff;
      border-top: 0.5px solid #f2f2f2;
      border-bottom: 0.5px solid #f2f2f2;
      padding-left: 0.3rem;
      padding-right: 0.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 1.2rem;
      padding-top: 0.15rem;
      padding-bottom: 0.15rem;
      .info-left {
        width: 30%;
        color: #999;
        font-size: .38rem;
      }
      .info-right {
        width: 65%;
        font-size: .38rem;
        text-align: right;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
      }
    }
  }
  .item-one {
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    width: 100%;
    padding: 0.35rem 0.4rem;
    border-radius: 0.2rem;
    margin-bottom: 0.2rem;
    .item-index {
      font-size: .38rem;
      line-height: 0.7rem;
      color: #999;
      font-weight: 600;
    }
    .item-line {
      font-size: .38rem;
      line-height: 0.55rem;
      color: #999;
      span {
        margin-left: 0.3rem;
      }
    }
    .remark-content {
      font-size: .38rem;
      color: #333;
      line-height: 0.7rem;
    }
  }
}
.info_right_edit {
  color: #409eff !important;
  cursor: pointer !important;
}
</style>